var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('img',{class:['gmb-brand-logo', { 'gmb-brand-logo--large': _vm.isLarge }],attrs:{"alt":"Geomob","src":_vm.imagePath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }